module.exports = {
  LOADING_USSD: 'LOADING_USSD',
  CLOSE_USSD: 'CLOSE_USSD',
  RECEIVE_USSD: 'RECEIVE_USSD'
};
